<div class="stage" role="status" aria-label="Carregando">
  <div class="streaks">
    <div class="streak streak-top"></div>
    <div class="streak streak-mid"></div>
    <div class="streak streak-bot"></div>
  </div>

  <div class="art">
    <div class="glow"></div>
    <img class="cat" src="assets/pantera-running.gif" alt="" />
  </div>

  <div class="ground"></div>
</div>

<div class="dots">
  <div class="dot"></div>
  <div class="dot"></div>
  <div class="dot"></div>
</div>
